import {showHidePassword} from './_components/input-password-show-hide/input-password-show-hide.js';
import {validateEntryForms} from './_components/validation-forms/validation-forms.js';
import cookie from "js-cookie";
import {initApp, resetStorage} from "./app.js";

const loginReturnSuffix = window.location.search + window.location.hash;

initApp();

window.person = window.person === undefined ? {} : window.person;
document.addEventListener('DOMContentLoaded', () => {


    validateEntryForms();
    showHidePassword();
    // inputMaskInit('entry__form', 'input-login', '+7 (999) 999-99-99');
    $('.input.input-login').inputmask({
        mask: '+7 (999) 999-99-99',
        // placeholder: '+7 (999) 999-99-99',
        insertMode: false,
        shiftPositions: false,
    })
    $('.input.input-phone').inputmask({
        mask: '+7 (999) 999-99-99',
        // placeholder: '+7 (999) 999-99-99',
        insertMode: false,
        shiftPositions: false,
    })

    var loginField = $(".form input[name=login]"),
        passwordField = $(".form input[name=password]"),
        checkBoxField = $('.form__group.login__remember input');

    if (localStorage.getItem('remember')) {
        checkBoxField.attr('checked', true)
        loginField.val(localStorage.getItem('login'))
        passwordField.val(localStorage.getItem('password'))
    }

    $('form').submit(function (event) {
        // var login = loginField[0].inputmask.unmaskedvalue(),
        var login = loginField.val().match(/\d/gi, '').join(''),
            password = passwordField.val(),
            checkBox = checkBoxField.is(':checked'),
            currentToastsCount = $(notify.container).children().length;

        if (!checkBox) {
            localStorage.removeItem('remember')
            localStorage.removeItem('login')
            localStorage.removeItem('password')
        }

        if (login.length > 0 && password.length > 0 && currentToastsCount === 0) {
            api.post('auth_client', {
                phone: login,
                password: password
            }).then(function (response) {
                console.log('auth_client', response)
                if (response && response.result) {
                    if (checkBox) {
                        localStorage.setItem('login', login.match(/\d/g).join('').slice(1))
                        localStorage.setItem('password', password)
                        localStorage.setItem('remember', true)
                    }
                    console.log(response.data.user_token)
                    cookie.set('usertoken', response.data.user_token)
                    localStorage.setItem('usertoken', response.data.user_token)
                    resetStorage()


                    if (loginReturnSuffix) {
                        const returnSearch = new URLSearchParams(window.location.search || loginReturnSuffix);
                        const startPage = returnSearch.get('page') === 'schedule'
                            ? 'schedule/'
                            : 'membership/';
                        return window.location = `/personal/${startPage}${loginReturnSuffix}`;
                    }
                    window.location = '/personal/membership/';
                }
            })
        }
    })

    $('body').on('click', '#restore-password-submit', async function (e) {
        e.preventDefault();
        let phone = $('#restore-password-form .input-phone').val();
        let captchaResponse = $('.g-recaptcha-response').val()
        if(!phone)
            return notify.alert('Телефон не введён')

        if(!captchaResponse)
            return notify.alert('Проверьте, что вы не робот')

        let response = await sendCode(phone, captchaResponse);
        if(response.result){
            MicroModal.show('enter-password');
            MicroModal.close('restore-password');
            grecaptcha.reset()
        }

    })

    $('body').on('click', '#enter-password-form .form__link', async function (e) {
        e.preventDefault();
        MicroModal.show('restore-password');
        MicroModal.close('enter-password');
        grecaptcha.reset()

        // let phone = $('#restore-password-form .input-phone').val();
        // await sendCode(phone);
        // notify.success('Отправили код повторно на телефон ' + phone)
    })

    $('body').on('click', '#enter-password-submit', async function (e) {
        e.preventDefault();
        let phone = $('#restore-password-form .input-phone').val(),
            sms_code = $('#sms_code').val()
        let t = await check_code(phone, sms_code);
        if (t) {
            window.hs_p = phone;
            window.hs_t = t;
            MicroModal.show('change-password-s');
            MicroModal.close('enter-password');
        }
    })

    $('body').on('click', '#change-password-submit', async function (e) {
        e.preventDefault();
        let password_new = $('#change-password-form [name=password-new]').val(),
            password_new_repeat = $('#change-password-form [name=password-new-repeat]').val();
        if (password_new === password_new_repeat) {
            setPassword(window.hs_p, password_new, window.hs_t);
        } else {
            notify.alert('Пароли не совпадают');
        }
    })
});
